import * as React from "react";
const SvgIcCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 6L5.21429 8L9.5 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgIcCheck;
